// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const BrushOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M7 16a1 1 0 011 1 2 2 0 01-2 2c-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95a1 1 0 011-1zM18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96a1 1 0 000-1.41l-1.34-1.34a.98.98 0 00-.7-.29zM7 14a3 3 0 00-3 3c0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2a4 4 0 004-4 3 3 0 00-3-3z","fill":"currentColor"}}]},"name":"brush","theme":"outlined"};

const BrushOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={BrushOutlinedSvg} />;
  BrushOutlined.displayName = 'BrushOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(BrushOutlined);
